/**
 * Screen-reader-only styles for an element that must stay in the accessibility
 * tree but not render. Lengths are explicit px strings: MUI `sx` treats bare
 * numbers <= 1 as percentages and `m` numbers as theme spacing.
 */
export const visuallyHidden = {
  position: "absolute",
  width: "1px",
  height: "1px",
  p: 0,
  m: "-1px",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  whiteSpace: "nowrap",
  border: 0,
} as const;
